<ng-template #dialogContent>
  <div class="flex flex-col gap-4">
    <ng-content></ng-content>
    <span class="font-bold" data-hj-suppress>{{ matchValue }}</span>
    <sb-form-field [label]="matchLabel" [control]="formControl" [errorWhen]="['touched']">
      <input type="text" sbAutofocus [formControl]="formControl" sbInput data-hj-suppress />
    </sb-form-field>
  </div>
</ng-template>
